<template>
  <div class="my-filter-content">
    <div class="my-fc-search">
      <div class="my-fc-search-top">
        <Input
          v-model="option.data.sVal"
          class="top-input"
          search
          enter-button
          clearable
          :placeholder="mlang('search')"
          @on-search="searchEvent" />
      </div>
      <div class="my-fc-search-content">
        <template v-if="valList.length">
          <ul class="my-fc-search-list my-fc-search-list-head">
            <li class="my-fc-search-item">
              <checkbox v-model="isAll" @on-change="changeAllEvent">
                {{ mlang('allCheck') }}
              </checkbox>
            </li>
          </ul>
          <ul class="my-fc-search-list my-fc-search-list-body">
            <li v-for="(item, sIndex) in valList" :key="sIndex" class="my-fc-search-item">
              <checkbox v-model="item.checked" @on-change="changeEvent">
                {{ item.value }}
              </checkbox>
            </li>
          </ul>
        </template>
        <template v-else>
          <div class="my-fc-search-empty">
            {{ mlang('noMatchingData') }}
          </div>
        </template>
      </div>
    </div>
    <div class="my-fc-footer">
      <Button status="primary" :disabled="disable" @click="confirmFilterEvent">
        {{ mlang('sure') }}
      </Button>
      <Button @click="resetFilterEvent">
        {{ mlang('reset') }}
      </Button>
    </div>
  </div>
</template>

<script>
import XEUtils from 'xe-utils';

export default {
  name: 'FilterContent',
  props: {
    params: Object
  },
  data() {
    return {
      size: 'mini',
      isAll: false,
      option: null,
      colValList: [],
      valList: [],
      disabled: false
    };
  },
  watch: {
    'params.column': {
      handler(val, oldVal) {
        if (val && oldVal && val.property !== oldVal.property) {
          this.load();
        }
      },
      deep: true
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      const { $table, column } = this.params;
      const { visibleData } = $table.getTableData();
      const option = column.filters[0];
      const { vals } = option.data;

      let colValList = Object.keys(XEUtils.groupBy(visibleData, column.property)).map(val => {
        return {
          checked: vals.includes(val),
          value: val
        };
      });
      colValList = colValList.filter((v) => {
        return v.value !== 'undefined';
      });
      this.option = option;
      this.colValList = colValList;
      this.valList = colValList;
      this.isAll = this.valList.every(item => {
        return item.checked;
      });
      this.setDisabled();
    },
    searchEvent() {
      const { option, colValList } = this;
      this.valList = option.data.sVal ? colValList.filter(item => item.value.indexOf(option.data.sVal) > -1) : colValList;
    },
    changeEvent() {
      this.isAll = this.valList.every(item => {
        return item.checked;
      });
      this.setDisabled();
    },
    changeAllEvent() {
      const { isAll } = this;
      this.valList.forEach(item => {
        item.checked = isAll;
      });
      this.setDisabled();
    },
    confirmFilterEvent(evnt) {
      const { params, option, valList } = this;
      const { data } = option;
      const { $panel } = params;
      data.vals = valList.filter(item => item.checked).map(item => item.value);
      $panel.changeOption(evnt, true, option);
      $panel.confirmFilter();
    },
    resetFilterEvent() {
      const { $panel } = this.params;
      $panel.resetFilter();
    },
    setDisabled() {
      let arr = this.valList.filter(item => {
        return item.checked;
      });
      this.disable = !arr.length;
    }
  }
};
</script>

<style lang="less" scoped>
.my-filter-content {
  padding: 10px;
  user-select: none;
}
.my-filter-content .my-fc-search .my-fc-search-top {
  position: relative;
  padding: 5px 0;
}
.my-filter-content .my-fc-search .my-fc-search-top > input {
  border: 1px solid #ABABAB;
  padding: 0 20px 0 2px;
  width: 200px;
  height: 22px;
  line-height: 22px;
}
.my-filter-content .my-fc-search .my-fc-search-content {
  padding: 2px 10px;
  text-align: left;
}
.my-filter-content .my-fc-search-empty {
  text-align: center;
  padding: 20px 0;
}
.my-filter-content .my-fc-search-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.my-filter-content .my-fc-search-list-body {
  overflow: auto;
  height: 120px;
}
.my-filter-content .my-fc-search-list .my-fc-search-item {
  padding: 2px 0;
  display: block;
}
.my-filter-content .my-fc-footer {
  text-align: right;
  padding-top: 10px;
}
.my-filter-content .my-fc-footer button {
  padding: 0 15px;
  margin-left: 15px;
}
.top-input {
    margin-right: 20px;
    width: 240px;
    border: 1px solid #dcdee2;
    border-radius: 4px;

    /deep/ .ivu-input.ivu-input-default {
      border: 0px;
      width: 200px;
    }

    /deep/ .ivu-input-icon-clear {
      margin-right: 17px;
      margin-top: 3px;
    }

    /deep/ .ivu-input-group-append.ivu-input-search {
      background: none !important;
      padding: 0 !important;
      border: 0px;
      border-color: #dcdee2 !important;
      border-left: 0px;

      .ivu-icon.ivu-icon-ios-search {
        padding-right: 5px;
        color: #808695;
      }
    }

    &:hover {
      border-color: #505766;
    }
}
</style>
